
<template>
  <div class="lang-menu-wrap"
    @click.self.stop="triggerBtn">
    <div class="lang-menu fade">
      <div class="menu-btn-wrap">
        <div class="menu-btn active"
          @click.stop="triggerBtn">
          <div class="menu-burger-wrapper">
            <div class="trigger menu-trigger">
              <div class="menu-burger icon-wrapper">
                <div class="line line-top"></div>
                <div class="line line-center"></div>
                <div class="line line-bottom"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="menu-list">
        <div class="title ft-30">{{$t('langBox.title')}}</div>
        <div class="lineee"></div>
        <div class="list">
          <div class="menu-item ft-60"
            @click.stop="chooseLang('zh-CN')">{{$t('langBox.menu[0]')}}</div>
          <div class="menu-item ft-60"
            @click.stop="chooseLang('en')">{{$t('langBox.menu[1]')}}</div>
          <div class="menu-item ft-60"
            @click.stop="chooseLang('ja')">{{$t('langBox.menu[2]')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TimelineLite, Power2 } from 'gsap/TweenMax'
import { qsa } from '@/util/dom.js'

export default {
  data () {
    return {
      active: false
    }
  },

  methods: {
    triggerBtn (calback) {
      const onComplete = () => {
        this.animating = false
        calback && typeof calback === 'function' && calback()
      }
      const el = this.$el
      const elfade = qsa('.fade', this.$el)
      const tl = new TimelineLite()

      if (this.animating) return
      this.animating = true

      if (this.active) {
        tl.staggerFromTo(
          elfade,
          0.8,
          {
            opacity: 1,
            transform: 'translateY(0)'
          },
          {
            opacity: 0,
            transform: 'translateY(-1400px)',
            ease: Power2.easeOut
          },
          0.1
        ).to(el, 0.4, {
          opacity: 0,
          ease: Power2.easeOut
        }).set(el, {
          left: '150%',
          onComplete
        })
      } else {
        tl.set(el, {
          left: 0
        }).to(el, 0.4, {
          opacity: 1,
          ease: Power2.easeOut
        }).staggerFromTo(
          elfade,
          0.8,
          {
            opacity: 0,
            transform: 'translateY(1400px)'
          },
          {
            opacity: 1,
            transform: 'translateY(0)',
            ease: Power2.easeOut
          },
          0.1,
          '-=0.4',
          onComplete
        )
      }

      this.active = !this.active
    },

    chooseLang (lang) {
      const self = this
      this.triggerBtn(() => {
        self.$store.dispatch('setLang', lang)
        self.$router.push('/')
        self.$router.go(0)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.lang-menu-wrap {
  position: fixed;
  top: 0;
  left: 150%;
  bottom: 0;
  right: 0;
  opacity: 0;
  background-color: rgba(3, 25, 47, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.lang-menu {
  background-color: #fff;
  min-width: 300px;
  min-height: 200px;
  width: 50%;
  height: 50%;

  display: flex;
  flex-direction: column;
}

.menu-btn-wrap {
  flex: none;
  display: flex;
  justify-content: flex-end;
}

.menu-btn {
  // z-index: 1050;
  // position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  // border-width: 1px;
  // border-style: solid;
  // border-radius: 25px;
  // border-color: #fff;
  // transition: border-color 0.8s;
  // transition-delay: 0s;
  cursor: pointer;

  .menu-burger-wrapper {
    width: 20px;
    height: 20px;

    .menu-trigger {
      position: relative;
      width: 100%;
      height: 100%;

      .menu-burger {
        width: 100%;
        height: 100%;
        position: relative;
        transition: transform 0.4s;

        .line {
          background-color: #000;
          position: absolute;
          left: 0;
          width: 100%;
          height: 1px;
          transform-origin: 50% 50%;
          transition: transform 0.5s 0.08s,background-color 0.8s,top 0.5s 0.08s,left 0.3s,opacity 0.5s,width 0.6s 0.05s;
        }
        .line-top {
          top: 0;
        }
        .line-center {
          top: 50%;
          width: 75%;
        }
        .line-bottom {
          top: 100%;
        }
      }
    }
  }
}

.menu-btn.active .menu-burger-wrapper .menu-trigger .menu-burger {
  transform: rotate(90deg);
}

.menu-btn.active .menu-burger-wrapper .menu-trigger .menu-burger .line-top {
  top: 50%;
  transform: rotate(45deg) translate(0, -50%);
}
.menu-btn.active .menu-burger-wrapper .menu-trigger .menu-burger .line-center {
  opacity: 0;
  left: -5px;
  width: 0;
}
.menu-btn.active .menu-burger-wrapper .menu-trigger .menu-burger .line-bottom {
  top: 50%;
  transform: rotate(-45deg) translate(0, -50%);
  width: 100%;
}

.menu-btn:hover .menu-burger-wrapper .menu-trigger .menu-burger .line-center {
  width: 100%;
}

.menu-list {
  flex: auto;
  display: flex;
  flex-direction: column;

  .title {
    flex: none;
    text-align: center;
    line-height: 60px;
    padding-bottom: 16px;
  }
  .lineee {
    flex: none;
    height: 1px;
    background-color: #eee;
  }

  .list {
    flex: auto;

    display: flex;
    justify-content: space-around;
    align-items: center;

    .menu-item {
      cursor: pointer;
      padding: 30px;
      color: #000;
      transition: color 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
      font-size: 2rem;
    }
    .menu-item:hover {
      color: #8fd6ed;
    }
  }
}
</style>
